module.exports = __webpack_public_path__ + "static/media/post.1907c1be.svg";